/* eslint-disable */

import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
// import { useTheme as useNextTheme } from "next-themes";
// import { Switch, useTheme } from "@nextui-org/react";
import CherryK from "../../assets/img/cherryk.png";
import { Link } from "react-router-dom";
// import { Badge, Grid } from "@nextui-org/react";
// import { Badge } from "@nextui-org/react";
import { Badge } from "@mui/material";
import {
  FaFileMedical,
  FaDatabase,
  FaAngleDown,
  FaRegUser,
  FaClipboardCheck,
  FaPowerOff,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutSuccess } from "../../redux/authRedux";
import Swal from "sweetalert2";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";
import { Settings } from "lucide-react";
import "./website-dashboard/sidebar.css";

function SideBar() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [accHOCount, setAccHOCount] = useState("");
  const [medHOCount, setMedHOCount] = useState("");
  const [proHOCount, setProHOCount] = useState("");

  const [accountLists, setAccountLists] = useState([]);
  const [count, setCount] = useState("");
  const [stockReqLists, setStockReqLists] = useState([]);
  const [reqCount, setReqCount] = useState("");
  const [stockTranLists, setStockTranLists] = useState([]);
  const [tranCount, setTranCount] = useState("");

  const user = useSelector((state) => state.auth.user);
  // console.log(user?.user?.role, 'role')
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    Swal.fire({
      title: "Success",
      text: "successfully Logout!",
      icon: "success",
      showConfirmButton: false,
      timer: 2000,
    }).then(function () {
      dispatch(logoutSuccess());
      navigate("/");
    });
  };
  useEffect(() => {
    const getAccountLists = async () => {
      try {
        api.get("accounting-lists").then((res) => {
          setAccountLists(res.data.list);
          setCount(res.data.list.length);
          // console.log(res.data.data, 'reorder')
        });

        // dispatch(setList("success"));
      } catch (err) {}
    };
    const getStockReqLists = async () => {
      try {
        const res = await api.get("stock-requests");
        setStockReqLists(res.data.list);
        setReqCount(res.data.list.filter((el) => !el.relatedTransfer).length);
        // setTreatmentLists(res.data.list)

        console.log(res.data.list);
      } catch (err) {
        console.log(err.message);
      }
    };

    const getStockTranLists = async () => {
      try {
        const res = await api.get(
          "stock-transfers",
          //'http://localhost:9000/api/treatments'
        );
        setStockTranLists(res.data.list);
        setTranCount(res.data.list.length);
        // setTreatmentLists(res.data.list)

        console.log(res.data.list, "tran");
      } catch (err) {
        console.log(err.message);
      }
    };
    const getProUnitLists = async () => {
      try {
        const res = await api.get("procedure-items?limit=30");
        // setProHOItemList(
        //   res.data.list.filter(el =>el.currentQuantity === 0)
        // )
        setProHOCount(
          res.data.list.filter((el) => el.currentQuantity <= el.reOrderQuantity)
            .length,
        );
        // console.log(res.data.list, 'pro list')
        // console.log(setProUnitLists.reOrderQuantity)
        // setProId(res.data.list._id)
      } catch (err) {
        console.log(err.message);
      }
    };

    const getMedUnitLists = async () => {
      try {
        const res = await api.get("medicine-items?limit=30");
        // setMedHOItemList(
        //   res.data.list.filter(el =>el.currentQuantity <= el.reOrderQuantity)
        // )
        // console.log(
        //   res.data.list.filter(el => el.reOrderQuantity >= el.currentQuantity),
        //   'ori med list'
        // )
        setMedHOCount(
          res.data.list.filter((el) => el.currentQuantity <= el.reOrderQuantity)
            .length,
        );
      } catch (err) {
        console.log(err.message);
      }
    };

    const getProAssLists = async () => {
      try {
        const res = await api.get("accessory-items?limit=30");
        // setAccHOItemList(
        //   res.data.list.filter(el =>el.currentQuantity <= el.reOrderQuantity)
        // )
        // console.log(res.data.list, 'pro ass list')
        setAccHOCount(
          res.data.list.filter((el) => el.currentQuantity <= el.reOrderQuantity)
            .length,
        );
      } catch (err) {
        console.log(err.message);
      }
    };

    getProAssLists();

    getMedUnitLists();
    getProUnitLists();

    getStockReqLists();
    getStockTranLists();

    getAccountLists();
    console.log("in Side Bar");
  }, []);

  return (
    <aside className="ws-sidebar">
      {/* <!-- Brand Logo --> */}
      <div className="ws-sidebar-logo">
        <img src={CherryK} alt="Cherry-K" />
      </div>

      <div className="ws-sidebar-nav">
        <nav>
          <ul>
            {/* //admin */}
            <li>
              <div
                data-bs-toggle="collapse"
                href="#collapseExample"
                role="button"
                aria-expanded="true"
                className="ws-sidebar-section-header"
              >
                <span><FaRegUser /> &nbsp; Admin</span>
                <FaAngleDown />
              </div>
            </li>
            <div className="collapse ws-sidebar-section" id="collapseExample">
              <ul style={{ listStyle: "none" }}>
                <li>
                  <Link to="/voucher" className="ws-sidebar-link">Voucher List</Link>
                </li>

                <li>
                  <Link to="/refund" className="ws-sidebar-link">Refund Request List</Link>
                </li>

                <li>
                  <Link to="/stock" className="ws-sidebar-link">Stock Count & Price</Link>
                </li>

                <li>
                  <Link to="/stock-req" className="ws-sidebar-link">
                    <Badge badgeContent={reqCount + "+"} color="error">Stock Request</Badge>
                  </Link>
                </li>

                <li>
                  <Link to="/stock-tran" className="ws-sidebar-link">
                    <Badge badgeContent={tranCount + "+"} color="error">Stock Transfer</Badge>
                  </Link>
                </li>
                <li>
                  <Link to="/purchase" className="ws-sidebar-link">Purchase Request</Link>
                </li>
                <li>
                  <Link to="/pur-tranlist" className="ws-sidebar-link">Purchase Approve List</Link>
                </li>
                <li>
                  <Link to="/issue-list" className="ws-sidebar-link">Issue List (HO)</Link>
                </li>
                <li>
                  <Link to="/receive-pos" className="ws-sidebar-link">Receive From POS</Link>
                </li>

                <li>
                  <Link to="/supplier" className="ws-sidebar-link">Supplier List</Link>
                </li>
                <li>
                  <Link to="/stock-list" className="ws-sidebar-link">Log List</Link>
                </li>
                <li>
                  <Link to="/fix_asset" className="ws-sidebar-link">Fixed Asset List</Link>
                </li>
                <li>
                  <Link to="/medicineSale" className="ws-sidebar-link">Medicine Sale Report</Link>
                </li>
                <li>
                  <Link to="/knas" className="ws-sidebar-link">K-Nas Voucher List</Link>
                </li>
                <li>
                  <Link to="/treatSale" className="ws-sidebar-link">Treatment Sales Report</Link>
                </li>
                <li>
                  <Link to="/doctor" className="ws-sidebar-link">Doctor List</Link>
                </li>
                <li>
                  <Link to="/discount" className="ws-sidebar-link">Discount List</Link>
                </li>
                <li>
                  <Link to="/member" className="ws-sidebar-link">Member List</Link>
                </li>
                <li>
                  <Link to="/reorder" className="ws-sidebar-link">
                    <Badge badgeContent={medHOCount + proHOCount + accHOCount + "+"} color="error">Reorder List</Badge>
                  </Link>
                </li>
                <li>
                  <Link to="/package" className="ws-sidebar-link">Package List</Link>
                </li>
                <li>
                  <Link to="/sale-return" className="ws-sidebar-link">Sales Return List</Link>
                </li>
                <li>
                  <Link to="/top10" className="ws-sidebar-link">Top 10 List</Link>
                </li>
                <li>
                  <Link to="/advance" className="ws-sidebar-link">Advance List</Link>
                </li>
                <li>
                  <Link to="/user" className="ws-sidebar-link">User List</Link>
                </li>
                <li>
                  <Link to="/customer" className="ws-sidebar-link">Customer List</Link>
                </li>
                <li>
                  <Link to="/expDateList" className="ws-sidebar-link">Expeired Date List</Link>
                </li>
                <li>
                  <Link to="/stock-history" className="ws-sidebar-link">Stock History</Link>
                </li>
              </ul>
            </div>

            <li>
              <div
                data-bs-toggle="collapse"
                href="#accountData"
                role="button"
                aria-expanded="false"
                className="ws-sidebar-section-header"
              >
                <span><FaDatabase /> &nbsp; Account Data</span>
                <FaAngleDown />
              </div>
            </li>

            <div className="collapse ws-sidebar-section" id="accountData">
              <ul style={{ listStyle: "none" }}>
                <li>
                  <Link to="/account_list" className="ws-sidebar-link">Account Lists</Link>
                </li>

                <li>
                  <Link to="/acc_type" className="ws-sidebar-link">Account Type</Link>
                </li>
                <li>
                  <Link to="/head" className="ws-sidebar-link">Heading Type</Link>
                </li>
                <li>
                  <Link to="/expense" className="ws-sidebar-link">Expense List</Link>
                </li>
                <li>
                  <Link to="/income" className="ws-sidebar-link">Income List</Link>
                </li>
                <li>
                  <Link to="/currency" className="ws-sidebar-link">Currency List</Link>
                </li>
                <li>
                  <Link to="/bank" className="ws-sidebar-link">Bank List</Link>
                </li>
                <li>
                  <Link to="/transfer-list" className="ws-sidebar-link">Transfer List</Link>
                </li>

                <li>
                  <Link to="/all-tran" className="ws-sidebar-link">All Transaction List</Link>
                </li>
                <li>
                  <Link to="/journal-list" className="ws-sidebar-link">Journal Entry</Link>
                </li>
                <li>
                  <Link to="/bc-report" className="ws-sidebar-link">Bank / Cash Report</Link>
                </li>
                <li>
                  <Link to="/acc-report" className="ws-sidebar-link">Account Report</Link>
                </li>
                <li>
                  <Link to="/transferreport-list" className="ws-sidebar-link">Transfer from Account Report</Link>
                </li>
              </ul>
            </div>

            <li>
              <div
                data-bs-toggle="collapse"
                href="#reportData"
                role="button"
                aria-expanded="false"
                className="ws-sidebar-section-header"
              >
                <span><FaClipboardCheck /> &nbsp; Report</span>
                <FaAngleDown />
              </div>
            </li>
            <div className="collapse ws-sidebar-section" id="reportData">
              <ul style={{ listStyle: "none" }}>
                <li>
                  <Link to="/profit-and-loss" className="ws-sidebar-link">Profit And Loss</Link>
                </li>
                <li>
                  <Link to="/balance_sheet" className="ws-sidebar-link">Balance Sheet</Link>
                </li>
                <li>
                  <Link to="/trail_bal" className="ws-sidebar-link">Trail Balance</Link>
                </li>
              </ul>
            </div>
            {/* Master Data */}
            {/* {user.user.role === 'Admin' && (
              <> */}
            <li>
              <div
                data-bs-toggle="collapse"
                href="#masterData"
                role="button"
                aria-expanded="false"
                className="ws-sidebar-section-header"
              >
                <span><FaFileMedical /> &nbsp; Master Data</span>
                <FaAngleDown />
              </div>
            </li>
            <div className="collapse ws-sidebar-section" id="masterData">
              <ul style={{ listStyle: "none" }}>
                <li>
                  <Link to="/category" className="ws-sidebar-link">Category</Link>
                </li>
                <li>
                  <Link to="/sub_category" className="ws-sidebar-link">Sub Category</Link>
                </li>
                <li>
                  <Link to="/brand" className="ws-sidebar-link">Brand List</Link>
                </li>
                <li>
                  <Link to="/medicine_list" className="ws-sidebar-link">Medicine List</Link>
                </li>
                <li>
                  <Link to="/pro_medicine" className="ws-sidebar-link">Procedure Medicine</Link>
                </li>

                <li>
                  <Link to="/pro-access" className="ws-sidebar-link">Procedure Accessory</Link>
                </li>
                <li>
                  <Link to="/gen" className="ws-sidebar-link">General Items</Link>
                </li>

                <li>
                  <Link to="/machine" className="ws-sidebar-link">Machine</Link>
                </li>
                <li>
                  <Link to="/treatC" className="ws-sidebar-link">Treatment</Link>
                </li>
                <li>
                  <Link to="/dental-treatment" className="ws-sidebar-link">Dental Treatment</Link>
                </li>
                {/* <li className="nav-item">
                  <Link to="/pro_medicine" className="nav-link">
                    <p>Treatment List</p>
                  </Link>
                </li> */}
              </ul>
            </div>
            {/* </>
            )} */}

            <li onClick={() => navigate("/setting")} style={{ cursor: "pointer" }}>
              <div className="ws-sidebar-link">
                <Settings size={18} />
                <span>Setting</span>
              </div>
            </li>

            <li className="ws-sidebar-footer">
              <button className="ws-sidebar-logout" onClick={logout}>
                <FaPowerOff />
                <span>Logout</span>
              </button>
            </li>
          </ul>
        </nav>
        {/* <!-- /.sidebar-menu --> */}
      </div>
      {/* <!-- /.sidebar --> */}
    </aside>
  );
}
export default SideBar;
